export default __webpack_public_path__ + "359048d61411e3e4e958e4026b53f7c4.svg";